import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = { textAlign: "center", fontSize: "30px", color: "rgb(131, 144, 155)", margin: "0 0 10px", fontWeight: "bold" };

function AddCity() {
  const [cityName, setCityName] = useState("");
  const [state, setState] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    HomeService.getStates().then((res) => setStates(res?.data || [])).catch(() => toast.error("Unable to load states."));
    HomeService.getCities().then((res) => setCities(res?.data || [])).catch(() => toast.error("Unable to load cities."));
  }, []);
  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const data = new FormData();
    data.append("image", file);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.status && res?.image) {
        setImage(res.image);
        toast.success("Image uploaded successfully!");
      } else {
        toast.error(res?.message || "Image upload failed. Please try again.");
      }
    } catch (error) {
      toast.error(error?.message || "Image upload failed. Please try again.");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await HomeService.addCity({ name: cityName, state, image });
      if (!res?.status) return toast.error(res?.message || "Failed to add city.");
      toast.success("City added successfully!"); navigate("/manage-city");
    } catch { toast.error("Failed to add city."); }
  };
  return <div className="main_wrap" style={{ marginTop: "6rem" }}><div className="container-fluid"><div className="mt-5"><div style={headLineStyle} className="page-headline">Add City</div><section className="chartBox_area"><form onSubmit={handleSubmit}><div className="row"><div className="col-md-6 mt-3"><label>State<span className="text-danger">*</span></label><select className="form-control" value={state} onChange={e => setState(e.target.value)} required><option value="">--- Select State ---</option>{states.filter(s => s.status).map(s => <option value={s._id} key={s._id}>{s.name}</option>)}</select></div><div className="col-md-6 mt-3"><label>City Name<span className="text-danger">*</span></label><input className="form-control" value={cityName} onChange={e => setCityName(e.target.value)} placeholder="Enter City Name" required /></div><div className="col-md-6 mt-3"><label>Upload City Image<span className="text-danger">*</span></label><input type="file" className="form-control" onChange={handleImageUpload} accept="image/*" required /></div>{image && <div className="col-md-6 mt-3"><label>Preview</label><img src={image} alt="City preview" width="100" style={{ display: "block", marginTop: 10 }} /></div>}</div><button type="submit" className="btn mt-3" style={{ background: "rgb(133, 218, 79)", borderRadius: 13 }}>Add City</button></form></section>
      {state && <section className="chartBox_area mt-4"><h4>Cities in {states.find((item) => item._id === state)?.name || "selected state"}</h4>{cities.filter((city) => (city.state?._id || city.state) === state).length ? <ul className="mb-0">{cities.filter((city) => (city.state?._id || city.state) === state).map((city) => <li key={city._id}>{city.name}</li>)}</ul> : <p className="mb-0 text-muted">No cities have been mapped to this state yet.</p>}</section>}
    </div></div></div>;
}
export default AddCity;
